
<h2 mat-dialog-title class="text-lg font-bold mb-1">  {{ isEditMode ? 'Editar Día Festivo' : 'Agregar Día Festivo' }}</h2>
<mat-dialog-content class="modal-content">
  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">

    <mat-form-field appearance="fill" class="col-span-2">
        <mat-label>Fecha </mat-label>
        <input matInput [matDatepicker]="pickerStart" [(ngModel)]="currentCreateCompanyHoliday.date" name="date" required>
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill" class="col-span-2">
        <mat-label>Descripción</mat-label>
        <input
          matInput
          [(ngModel)]="currentCreateCompanyHoliday.description"
          name="description"
          required
        />
      </mat-form-field>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button
    mat-raised-button
    color="primary"
    (click)="save()"
    [disabled]="!createForm.valid"
    class="justify-end"
  >
  {{ isEditMode ? 'Actualizar' : 'Guardar' }}
  </button>
</mat-dialog-actions>
